import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { StorageService } from '../../_services/storage.service';
import { filter, Subscription } from 'rxjs';
import { Role } from 'src/app/_helpers/auth.constants';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
    selector: 'navbar-cmp',
    templateUrl: './navbar.component.html'
})
export class NavbarComponent implements OnInit, OnDestroy {
    isMobileMenuOpen = false;
    activeTab: string | null = null;
    private routerSubscription?: Subscription;

    constructor(
        private readonly router: Router,
        private readonly storageService: StorageService,
        private readonly authService: AuthService
    ) { }

    ngOnInit() {
        // Initialize active tab based on current route
        this.updateActiveTabFromRoute(this.router.url);

        // Subscribe to route changes
        this.routerSubscription = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.updateActiveTabFromRoute(event.url);
        });
    }

    ngOnDestroy() {
        // Clean up subscription
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    private updateActiveTabFromRoute(url: string) {
        if (url.includes('/integration-guide')) {
            this.activeTab = 'integration';
        } else if (url.includes('/api-explorer')) {
            this.activeTab = 'api';
        } else {
            this.activeTab = 'home';
        }
    }

    navigateToLogin() {
        this.router.navigate(['/auth/login']);
    }

    toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }

    sidebarClose() {
        // Method for compatibility with admin layout
        // Landing navbar doesn't have sidebar functionality
    }

    isLoggedIn(): boolean {
        return this.storageService.isLoggedIn();
    }

    setActiveTab(tab: string) {
        this.activeTab = tab;
        // Navigate based on the tab
        if (tab === 'integration' && this.storageService.isLoggedIn()) {
            this.router.navigate(['/integration-guide']);
        } else if (tab === 'integration') {
            this.router.navigate(['/auth/integration-guide']);
        } else if (tab === 'api' && this.storageService.isLoggedIn()) {
            this.router.navigate(['/api-explorer']);
        } else if (tab === 'api') {
            this.router.navigate(['/auth/api-explorer']);
        } else if (tab === 'home') {
            this.authService.getRole() == Role.PAY10_ADMIN ?
                this.router.navigate(['/user-management']) :
                this.router.navigate(['/encryption-secret']);
        }
    }

    navigateToHome(): void {
        this.router.navigate(['/home']);
    }
}
